import axios from 'axios';
import crud from "./crud";

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}
const baseurl = 'refundfinance';
export default {
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 
                'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'status', 
                'nomor', 'CustCode','CustName','no_kontrak','no_agreement','namabank', 'reference',
                 'tgldue1', 'tgldue2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `/${baseurl}/detail/${obj.settleKey}`;
                const {data} = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    postingtrx(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("refundfinance/postingtrx", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    unpostingtrx(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("refundfinance/unpostingtrx", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    disburmentlist(obj){
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'status', 'nomor', 'customer', 'namabank', 'reference', 'tgldue1', 'tgldue2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/disburment/${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    disburmentdetail(obj){
        return new Promise(async (resolve, reject) => {
            try {
                const url = `/${baseurl}/disburment-detail/${obj.disburmentKey}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    disburmentsave(obj){
        return new Promise(async (resolve, reject) => {
            try {
                const url = `/${baseurl}/disburment-save`;
                const {data} = await axios.post(url,obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    postingdisburtrx(obj){
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("refundfinance/postingdisburtrx", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    unpostingdisburtrx(obj){
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("refundfinance/unpostingdisburtrx", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    printmemo(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`${baseurl}/printmemo/${obj.settleKey}`);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    approval(formData) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post(`${baseurl}/send2wf`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    approvalUndo(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.put(`${baseurl}/send2wfCancel/${obj.settleKey}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    printjv(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url;
            let str = '';
            try {
                str = '?key=' + encodeURIComponent(obj.settleKey);
                url = `/${baseurl}/printjv`;

                url += str;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
}